module.exports = __webpack_public_path__ + "media/bootstrap-icons/window-47d3ab3c.svg";